(() => {
  // Code nicht im HTML. (Theme-only kann es nie "wirklich" geheim halten,
  // aber so taucht er nicht im DOM/Markup auf.)
  const CODE_B64 = "Z2FtZTU="; // base64 für "game5"
  const QUESTIONS_TO_ASK = 5;
  const POINTS_PER_CORRECT = 100;
  const WIN_POINTS = QUESTIONS_TO_ASK * POINTS_PER_CORRECT;

  function shuffle(array) {
    const a = [...array];
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function trapFocus(modal) {
    const focusable = modal.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    function onKeyDown(e) {
      if (e.key !== "Tab") return;
      if (focusable.length === 0) return;

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }

    modal.addEventListener("keydown", onKeyDown);
    return () => modal.removeEventListener("keydown", onKeyDown);
  }

  // Simple fireworks/confetti canvas (monochrome-ish, passt zu jedem Theme)
  function launchFireworks(canvas, durationMs = 1800) {
  const ctx = canvas.getContext("2d");
  const dpr = window.devicePixelRatio || 1;

  function resize() {
    const rect = canvas.getBoundingClientRect();
    const w = Math.max(1, rect.width);
    const h = Math.max(1, rect.height);
    canvas.width = Math.floor(w * dpr);
    canvas.height = Math.floor(h * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    return { w, h };
  }

  // einmal nach Layout resizen, damit es wirklich die Popup-Größe hat
  let { w: W0, h: H0 } = resize();

  const particles = [];
  const start = performance.now();
  const end = start + durationMs;

  // Farben wirken lebendiger
  ctx.globalCompositeOperation = "lighter";

  function rand(min, max) {
    return min + Math.random() * (max - min);
  }

  function addBurst(W, H) {
    // über die ganze Popup-Fläche verteilen
    const cx = rand(W * 0.15, W * 0.85);
    const cy = rand(H * 0.18, H * 0.70);

    const count = Math.floor(rand(70, 110));
    const hue = Math.floor(rand(0, 360));

    for (let i = 0; i < count; i++) {
      const angle = Math.random() * Math.PI * 2;
      const speed = rand(2.0, 7.0);
      particles.push({
        x: cx,
        y: cy,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        g: rand(0.05, 0.10),
        life: 1,
        decay: rand(0.010, 0.018),
        size: rand(1.5, 3.5),
        hue: (hue + rand(-25, 25) + 360) % 360
      });
    }
  }

  // initiale Bursts
  addBurst(W0, H0);
  addBurst(W0, H0);
  addBurst(W0, H0);

  // nachzünden
  const fuse = [start + 220, start + 520, start + 820, start + 1120];

  let lastT = start;

  function tick(t) {
    const dt = clamp((t - lastT) / 16.67, 0.5, 2.5);
    lastT = t;

    const { w: W, h: H } = resize();
    W0 = W; H0 = H;

    // transparent: komplett clearen (kein Schleier)
    ctx.clearRect(0, 0, W, H);

    while (fuse.length && t >= fuse[0]) {
      fuse.shift();
      addBurst(W, H);
    }

    for (let i = particles.length - 1; i >= 0; i--) {
      const p = particles[i];

      p.vy += p.g * dt;
      p.x += p.vx * dt;
      p.y += p.vy * dt;
      p.life -= p.decay * dt;

      if (p.life <= 0 || p.y > H + 40 || p.x < -40 || p.x > W + 40) {
        particles.splice(i, 1);
        continue;
      }

      const alpha = clamp(p.life, 0, 1);
      ctx.globalAlpha = alpha;
      ctx.fillStyle = `hsla(${p.hue}, 95%, 60%, ${alpha})`;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
      ctx.fill();
    }

    if (t < end || particles.length > 0) {
      requestAnimationFrame(tick);
    } else {
      ctx.clearRect(0, 0, W0, H0);
      ctx.globalCompositeOperation = "source-over";
      ctx.globalAlpha = 1;
    }
  }

  requestAnimationFrame(tick);
}


  function showToast(toastEl, msg) {
    toastEl.textContent = msg;
    toastEl.classList.add("is-show");
    clearTimeout(showToast._t);
    showToast._t = setTimeout(() => toastEl.classList.remove("is-show"), 1200);
  }

  function init(root) {
    const openBtn = root.querySelector("[data-ms-quiz-open]");
    const modal = root.querySelector("[data-ms-quiz]");
    const closeBtn = root.querySelector("[data-ms-quiz-close]");
    const restartBtn = root.querySelector("[data-ms-quiz-restart]");
    const quitBtn = root.querySelector("[data-ms-quiz-quit]");

    const qEl = root.querySelector("[data-ms-quiz-question]");
    const aWrap = root.querySelector("[data-ms-quiz-answers]");
    const feedback = root.querySelector("[data-ms-quiz-feedback]");
    const feedbackText = root.querySelector("[data-ms-quiz-feedback-text]");
    const nextBtn = root.querySelector("[data-ms-quiz-next]");

    const chipStep = root.querySelector("[data-ms-quiz-step]");
    const chipPoints = root.querySelector("[data-ms-quiz-points]");
    const bar = root.querySelector("[data-ms-quiz-bar]");

    const endWrap = root.querySelector("[data-ms-quiz-end]");
    const resultBox = root.querySelector("[data-ms-quiz-result]"); // ✅ NEU
    const codeBox = root.querySelector("[data-ms-quiz-codebox]");
    const playWrap = root.querySelector("[data-ms-quiz-play]");
    const codeEl = root.querySelector("[data-ms-quiz-code]");
    const copyBtn = root.querySelector("[data-ms-quiz-copy]");
    const toast = root.querySelector("[data-ms-quiz-toast]");
    const canvas = root.querySelector("[data-ms-quiz-canvas]");

    const dataEl = root.querySelector('script[type="application/json"][data-ms-quiz-data]');
    if (!openBtn || !modal || !dataEl) return;

    const allQuestionsRaw = JSON.parse(dataEl.textContent || "[]");

    let picked = [];
    let i = 0;
    let points = 0;
    let untrap = null;
    let lastFocus = null;

    // Build picked questions with shuffled answer order
    function buildPicked() {
      const base = shuffle(allQuestionsRaw).slice(0, QUESTIONS_TO_ASK);

      return base.map(q => {
        const answers = q.a.map((text, idx) => ({
          text,
          isCorrect: idx === q.correct
        }));
        const shuffled = shuffle(answers);
        return {
          q: q.q,
          fact: q.fact,
          answers: shuffled
        };
      });
    }

    function setProgress() {
      chipStep.textContent = `Frage ${Math.min(i + 1, QUESTIONS_TO_ASK)}/${QUESTIONS_TO_ASK}`;
      chipPoints.textContent = `Punkte: ${points}`;
      bar.style.width = `${(i / QUESTIONS_TO_ASK) * 100}%`;
    }

    function renderQuestion() {
      const q = picked[i];
      if (!q) return;

      qEl.textContent = q.q;
      aWrap.innerHTML = "";

      q.answers.forEach((ans, idx) => {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "ms-quiz__answer";
        btn.textContent = ans.text;
        btn.setAttribute("data-idx", String(idx));
        btn.addEventListener("click", () => onAnswer(idx), { once: true });
        aWrap.appendChild(btn);
      });

      feedback.classList.remove("is-show");
      feedback.classList.remove("is-correct", "is-wrong");
      nextBtn.disabled = true;
      setProgress();

      playWrap.classList.remove("ms-quiz__shake", "ms-quiz__pulse");
      bar.style.width = `${(i / QUESTIONS_TO_ASK) * 100}%`;
    }

    function onAnswer(idx) {
      const q = picked[i];
      const buttons = aWrap.querySelectorAll("button");
      buttons.forEach(b => b.disabled = true);

      const isCorrect = !!q.answers[idx]?.isCorrect;

      if (isCorrect) {
        points += POINTS_PER_CORRECT;     // exakt 100 pro richtig
        feedbackText.innerHTML = `<strong>Richtig!</strong> ${q.fact}`;
        playWrap.classList.add("ms-quiz__pulse");
        feedback.classList.remove("is-wrong");
        feedback.classList.add("is-correct");
      } else {
        feedbackText.innerHTML = `<strong>Fast!</strong> ${q.fact}`;
        playWrap.classList.add("ms-quiz__shake");
        feedback.classList.remove("is-correct");
        feedback.classList.add("is-wrong");
      }

      feedback.classList.add("is-show");
      nextBtn.disabled = false;
      setProgress();
      bar.style.width = `${((i + 0.65) / QUESTIONS_TO_ASK) * 100}%`;
    }

    function next() {
      i += 1;
      if (i >= QUESTIONS_TO_ASK) {
        finish();
      } else {
        renderQuestion();
      }
    }

    function finish() {
      bar.style.width = "100%";

      playWrap.hidden = true;
      endWrap.hidden = false;

      const won = points === WIN_POINTS; // nur bei 500 Punkten gewinnt man

      // ✅ Ergebnisfarbe setzen (grün bei win, rot bei lose)
      if (resultBox) {
        resultBox.classList.remove("is-win", "is-lose");
        resultBox.classList.add(won ? "is-win" : "is-lose");
      }

      root.querySelector("[data-ms-quiz-end-title]").textContent = won
        ? "🎆 Perfekt! 500 Punkte – Jackpot!"
        : `👏 ${points} Punkte – knapp!`;

      // ⚠️ Code NICHT im Text verraten
      root.querySelector("[data-ms-quiz-end-sub]").textContent = won
        ? "Du hast den Gutschein freigespielt. Kopiere deinen Code und löse ihn ab einem Warenkorbwert von €50,- ein. Pro Kunde:in nur einmal einlösbar 😄"
        : "Für den Gutschein brauchst du 500 Punkte (5/5 richtig). Nochmal versuchen?";

      // Code erst JETZT (und nur bei Gewinn) in den DOM schreiben
      if (won) {
        const code = atob(CODE_B64);

        if (codeBox) {
          codeBox.hidden = false;
          codeBox.removeAttribute("hidden"); // ✅ garantiert sichtbar
        }

        codeEl.textContent = code;
        copyBtn.disabled = false;

        launchFireworks(canvas, 1800);
      } else {
        if (codeBox) {
          codeBox.hidden = true;
          codeBox.setAttribute("hidden", ""); // ✅ garantiert unsichtbar
        }

        codeEl.textContent = "—";
        copyBtn.disabled = true;
      }
    }

    function startGame() {
      picked = buildPicked();
      i = 0;
      points = 0;

      endWrap.hidden = true;
      playWrap.hidden = false;

      // ✅ Ergebnis-Farben resetten
      if (resultBox) resultBox.classList.remove("is-win", "is-lose");

      // ✅ Screen & Code-UI IMMER zurücksetzen/verstecken
      if (codeBox) {
        codeBox.hidden = true;
        codeBox.setAttribute("hidden", "");
      }
      codeEl.textContent = "—";
      copyBtn.disabled = true;

      renderQuestion();
      setTimeout(() => {
        const first = aWrap.querySelector("button");
        if (first) first.focus();
      }, 0);
    }

    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      modal.setAttribute("aria-hidden", "false");
      untrap = trapFocus(modal);
      startGame();
      closeBtn.focus();
    }

    function close() {
      modal.hidden = true;
      modal.setAttribute("aria-hidden", "true");
      if (untrap) untrap();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    openBtn.addEventListener("click", open);
    closeBtn.addEventListener("click", close);
    quitBtn?.addEventListener("click", close);
    restartBtn?.addEventListener("click", startGame);

    modal.addEventListener("click", (e) => {
      if (e.target === modal) close();
    });

    document.addEventListener("keydown", (e) => {
      if (modal.hidden) return;
      if (e.key === "Escape") close();
    });

    nextBtn.addEventListener("click", next);

    copyBtn.addEventListener("click", async () => {
      if (copyBtn.disabled) return;
      const code = atob(CODE_B64);
      try {
        await navigator.clipboard.writeText(code);
        showToast(toast, "✅ Gutschein kopiert!");
      } catch {
        const t = document.createElement("textarea");
        t.value = code;
        t.style.position = "fixed";
        t.style.opacity = "0";
        document.body.appendChild(t);
        t.select();
        document.execCommand("copy");
        document.body.removeChild(t);
        showToast(toast, "✅ Gutschein kopiert!");
      }
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-ms-quiz-root]").forEach(init);
  });
})();
